import React from "react";
import { Helmet } from "react-helmet";
import AboutCtaSection from "./components/AboutCtaSection";
import AboutCultureSection from "./components/AboutCultureSection";
import AboutDualImageSection from "./components/AboutDualImageSection";
import AboutFooter from "./components/AboutFooter";
import AboutHeaderSection from "./components/AboutHeaderSection";
import AboutIdeaSection from "./components/AboutIdeaSection";
import AboutNextChapterSection from "./components/AboutNextChapterSection";
import AboutPlatformSection from "./components/AboutPlatformSection";
import AboutStatsSection from "./components/AboutStatsSection";
import AboutWhyMattersSection from "./components/AboutWhyMattersSection";

const AboutUs = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | About Us</title>
      </Helmet>

      <AboutHeaderSection />

      <AboutStatsSection />

      <AboutIdeaSection />

      <AboutPlatformSection />

      <AboutDualImageSection />

      <AboutWhyMattersSection />

      <AboutCultureSection />

      <AboutNextChapterSection />

      <AboutCtaSection />

      <AboutFooter />
    </div>
  );
};

export default AboutUs;
